import {
  GET_SUBSCRIPTION_LIST,
  GET_SUBSCRIPTION_LIST_SUCCESS,
  GET_SUBSCRIPTION_LIST_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getSubscriptionListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SUBSCRIPTION_LIST:
      return { ...state, loading: true };
    case GET_SUBSCRIPTION_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_SUBSCRIPTION_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getSubscriptionListReducer;
